import { saveFiles } from '@/services/s3-upload-service';
import { sendProposal } from '@/services';
import { removeCurrencyFormat } from '@/utils';
import { mapActions } from 'vuex';
export default {
    name: 'SendProposal',
    data: () => ({
        observation: '',
        proposalValue: '',
        attachments: [],
        loading: false
    }),
    props: { show: Boolean, width: String, height: String, isMobile: Boolean, offer: Object, competition: Object },
    methods: {
        ...mapActions('notification', ['showNotification']),
        async sendProposal() {
            this.loading = true;
            if (this.validateForm) {
                let files = [];
                try {
                    if (this.attachments.length) {
                        try {
                            const uploadFilesToS3BucketResponse = await saveFiles(this.attachments);
                            files = uploadFilesToS3BucketResponse != undefined ? uploadFilesToS3BucketResponse : [];
                        } catch (error) {
                            console.error(error);
                        }
                    }
                    const formData = {
                        files: files,
                        service_value: removeCurrencyFormat(this.proposalValue),
                        obs: this.observation,
                        competition_id: this.offer.competition
                    };
                    await sendProposal(formData);
                    this.showNotification({ text: 'Proposta enviada com sucesso', type: 'success' });
                    this.$emit('close', false);
                } catch (error) {
                    this.$emit('close', false);
                    this.showNotification({ text: 'Erro interno nos servidores', type: 'success' });
                    console.error(error);
                } finally {
                    this.loading = false;
                    this.$emit('initializeData');
                }
            }
        }
    },
    computed: {
        validateForm() {
            return parseFloat(this.proposalValue) > 0;
        }
    }
};
